export default __webpack_public_path__ + "static/media/evento_kilometraje_masivo.d40e9a64.xlsx";